/* eslint-disable no-prototype-builtins */
import axios from 'axios'

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import EditHobbyItem from '../items/EditHobbyItem'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { positionChangeWidthSm, swipelyticsTurquoise } from '../../../../helpers/variableDefaults'
import { standardButton } from '../../../../helpers/buttons'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { standardErrorContainer } from '../../../../helpers/errors'
import { saveSuccessfulTypography, advisoryTypography } from '../../../../helpers/typographies'
import { Input } from '../../../../helpers/globalHelpers'
import { modifyDatingProfileInDatabase } from '../../../../helpers/modifyInDatabase'
import { titleAndAdvisoryJSX, saveAndCancelButtonsJSX } from '../../../../helpers/commonJSX'

export const editHobbiesJSX = (
  isDemo,
  user, setUser,
  datingProfile, setDatingProfile,
  previousDatingProfile, setPreviousDatingProfile,
  selectedHobbyIndex, setSelectedHobbyIndex,
  newHobby, setNewHobby,
  openHobbySelectModal, setOpenHobbySelectModal,
  customHobbySelected, setCustomHobbySelected,
  openMediaItemSelectModal, openPromptSelectModal, openAboutMeSelectModal,
  loading, setLoading,
  saveSuccessful, setSaveSuccessful,
  errors, setErrors,
  resetLoadingAndErrors, resetSaveSuccessful,
  width
) => {

  const hobbyIndexesArray = [0, 1, 2, 3, 4]

  const tapDisabled = () => {
    return (
      openPromptSelectModal 
      || openAboutMeSelectModal 
      || openHobbySelectModal
      || loading.loading
      || loading.mediaItems
      || loading.aboutMe
      || loading.prompts
      || loading.hobbies
      || loading.selectMediaItem
      || loading.selectAboutMe
      || loading.selectPrompt
      || loading.selectHobby
    )
  }

  const showSaveAndCancelButtons = () => {
    // console.log('mediaItem.url ->', Object.keys(mediaItem).length > 0 ? mediaItem.url : 'No Url')
    // console.log('previousURL ->', previousURL)
    // console.log('mediaItem.url === previousURL ->', mediaItem.url === previousURL)
    return !(
      Object.keys(datingProfile).length > 0
      && 'bio' in datingProfile
      && 'hobbies' in datingProfile.bio
      && datingProfile.bio.hobbies.length === previousDatingProfile.bio.hobbies.length
      && 
        datingProfile.bio.hobbies.filter((item, itemIndex) => (itemIndex > previousDatingProfile.bio.hobbies.length || item !== previousDatingProfile.bio.hobbies[itemIndex])).length === 0 
    )
  }

  const handleSelectItem = (e, selectedIndex) => {
    console.log('handleSelectItem runs')
    e.preventDefault()
    if (
      !(tapDisabled())
    ) {
      resetLoadingAndErrors()
      resetSaveSuccessful()
      setSelectedHobbyIndex(selectedIndex)
      setNewHobby(datingProfile.bio.hobbies.length > selectedIndex ? datingProfile.bio.hobbies[selectedIndex] : '')
      setOpenHobbySelectModal(true)
    }
  }

  const handleCancelPressed = () => {
    // console.log('handleCancelPressed runs')
    const resetBio = {
      ...datingProfile.bio,
      hobbies: previousDatingProfile.bio.hobbies,
    }
    setDatingProfile({ ...datingProfile, bio: { ...resetBio } })
    resetSaveSuccessful()
  }

  const handleSavePressed = async () => {
    console.log('handleSavePressed runs')
    const newBio = {
      ...previousDatingProfile.bio,
      hobbies: [ ...datingProfile.bio.hobbies ],
    }

    if (isDemo) {

      const updatedDatingProfilesForUser = user.datingProfiles.map((userDatingProfile, userDatingProfileIndex) => {
        return (
          userDatingProfile._id !== datingProfile._id 
            ?
            userDatingProfile
            :
            { 
              ...userDatingProfile,
              bio: { ...newBio },
            }
        )
      })
      setUser({ 
        ...user, 
        datingProfiles: [ ...updatedDatingProfilesForUser ],
      })
      
      setPreviousDatingProfile({ 
        ...previousDatingProfile, 
        bio: { ...newBio }, 
      })

    } else {

      const objectToUpload = {
        bio: { ...newBio },
      }
      // console.log('objectToUpload ->', objectToUpload)

      await modifyDatingProfileInDatabase(`hobbies`, datingProfile._id, objectToUpload, errors, setErrors, loading, setLoading)

      const updatedDatingProfilesForUser = user.datingProfiles.map((userDatingProfile, userDatingProfileIndex) => {

        const fiveHobbiesSorted = [ ...userDatingProfile.bio.hobbies, ...datingProfile.bio.hobbies ].filter(hobbyString => hobbyString.length > 0).slice(0, 5)
        while (fiveHobbiesSorted < 5) {
          fiveHobbiesSorted.push('')
        }

        return (
          userDatingProfile._id !== datingProfile._id 
            ?
            (userDatingProfile.type === 'hinge' || user.bio.hobbies.filter(hobbyString => hobbyString.length > 0).length >= 5)
              ?
              userDatingProfile
              :
              {
                ...userDatingProfile,
                bio: {
                  ...userDatingProfile.bio,
                  hobbies: [ ...fiveHobbiesSorted ],
                },
              }
            :
            { 
              ...userDatingProfile,
              bio: { ...newBio },
            }
        )
      })

      // Add default hobbies to User if necessary
      const newUserBioObj = { ...user.bio }
      if (
        datingProfile.bio.hobbies.length > 0
        && datingProfile.bio.hobbies.filter(hobbyString => hobbyString.length > 0).length > 0
        && 'hobbies' in user.bio
        && user.bio.hobbies !== null
        && Array.isArray(user.bio.hobbies)
        && user.bio.hobbies.filter(hobbyString => hobbyString.length > 0).length < 10
      ) {

        if (
          user.bio.hobbies.length === 0
          || user.bio.hobbies.filter(hobbyString => hobbyString.length > 0).length === 0
        ) {
          const filteredDatingProfileHobbies = datingProfile.bio.hobbies.filter(hobbyString => hobbyString.length > 0)
          const filteredCurrentHobbies = [ ...filteredDatingProfileHobbies ]
          
          while (filteredCurrentHobbies.length < 5) {
            filteredCurrentHobbies.push('')
          }

          newUserBioObj.hobbies = [ ...filteredCurrentHobbies ].slice(0, 10)
        } else {

          const filteredCurrentHobbies = user.bio.hobbies.filter(hobbyString => hobbyString.length > 0)

          for (let i = 0; i < datingProfile.bio.hobbies.length; i++) {
            
            if (
              datingProfile.bio.hobbies[i].length > 0
              && filteredCurrentHobbies.length < 10
              && !(user.bio.hobbies.includes(datingProfile.bio.hobbies[i]))
            ) {
              filteredCurrentHobbies.push(datingProfile.bio.hobbies[i])
            }
          }

          while (filteredCurrentHobbies.length < 5) {
            filteredCurrentHobbies.push('')
          }

          newUserBioObj.hobbies = [ ...filteredCurrentHobbies ].slice(0, 10)
        }
      
      }


      setUser({ 
        ...user, 
        datingProfiles: [ ...updatedDatingProfilesForUser ],
        bio: { ...newUserBioObj },
      })

      setPreviousDatingProfile({ 
        ...previousDatingProfile, 
        bio: { ...newBio }, 
      })

    }
  }

  return (
    <Box
      sx={{
        py: 3, mb: 2,
        width: width < positionChangeWidthSm ? '100%' : '90%',
        maxWidth: '600px',
        backgroundColor: showSaveAndCancelButtons() ? 'lightgray' : 'whitesmoke',
        borderRadius: width < positionChangeWidthSm ? 0 : 3, boxShadow: width < positionChangeWidthSm ? 3 : 3,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '90%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        <Box sx={{ width: '100%' }}>
          <Input type="text" autoFocus="autoFocus" />
        </Box>

        {/* Title and Advisory JSX */}
        {titleAndAdvisoryJSX(
          'Hobbies', 
          `*Tap to edit
          *Drag and drop to reorder`,
          0
        )}


        {/* Hobbies */}
        <DndProvider backend={HTML5Backend}>
          {hobbyIndexesArray.map((hobbyIndex) => (
            <Box
              key={hobbyIndex}
              onClick={(e) => handleSelectItem(e, hobbyIndex)}
              sx={{
                my: 1,
                width: '100%',
                backgroundColor: 'white',
                borderRadius: 3, boxShadow: 3,
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start',
              }}
            >
              {'bio' in datingProfile && datingProfile.bio !== null && Object.keys(datingProfile.bio).length > 0 && 'hobbies' in datingProfile.bio && datingProfile.bio.hobbies.length > hobbyIndex && datingProfile.bio.hobbies[hobbyIndex].length > 0
                ?
                <EditHobbyItem hobbyItem={datingProfile.bio.hobbies[hobbyIndex]} datingProfile={datingProfile} setDatingProfile={setDatingProfile} hobbyItemIndex={hobbyIndex} loading={loading} tapDisabled={tapDisabled} handleSelectItem={handleSelectItem} />
                :
                <Box
                  onClick={(e) => handleSelectItem(e, hobbyIndex)}
                  disabled={tapDisabled()}
                  sx={{
                    width: '100%',
                    backgroundColor: 'gray',
                    boxShadow: 3, 
                    borderRadius: '5px', 
                    cursor: tapDisabled() ? '' : 'pointer',
                    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                  }}
                >
                  <AddIcon 
                    color='primary'
                    sx={{
                      my: 1,
                      // boxShadow: 3, 
                      borderRadius: '50%',
                      border: 2, 
                      borderColor: 'black',
                      backgroundColor: 'white',
                      width: '35px', height: '35px',
                    }}
                  />
                </Box>
              }
              
            </Box>
          ))}
        </DndProvider>


        {/* Save and Cancel Buttons */}
        {showSaveAndCancelButtons()
          && saveAndCancelButtonsJSX(
            loading.hobbies,
            (!(showSaveAndCancelButtons()) || loading.hobbies),
            handleCancelPressed,
            handleSavePressed,
            0,
            0,
            2,
            'warning',
            'primary'
          )
        }

        {/* Loading */}
        {loading.hobbies &&
          advisoryTypography(`Uploading Changes...`, 'center')
        }

        {/* Error Message */}
        {errors.hobbies &&
          standardErrorContainer(`There was an error uploading the changes. Check your Internet connection and try again.`)
        }

        {/* Save Successful */}
        {saveSuccessful.hobbies &&
          saveSuccessfulTypography()
        }
      </Box>
    </Box>
  )
}